(function () {
    'use strict';

    angular
        .module('app')
        .directive('popupcmd', popupcmd);

    popupcmd.$inject = ['$timeout'];

    function popupcmd($timeout) {
        // Usage:
        //     <popupcmd></popupcmd>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'E',
            scope: {
                show: '=',
                close: '&onClose',
                uid: "@"
            },
            replace: true,
            transclude: true,
            templateUrl: 'app/common/templates/popupcmd.html'
        };
        return directive;

        function link(scope, element, attrs) {

            var overlay = $(element).find("popup-overlay");

            $(overlay).appendTo(document.body);

            scope.maxHeight = "none";
            scope.maxWidth = "none";
            
            //make modal
            var overlay = element[0].getElementsByClassName('ng-modal-overlay');

            angular.element(overlay).bind('click', function (e) {
                e.preventDefault();
            })

            scope.dialogStyle = {};
            if (attrs.width)
                scope.dialogStyle.width = attrs.width;
            if (attrs.height)
                scope.dialogStyle.height = attrs.height;

            if (attrs.maxHeight)
                scope.maxHeight = attrs.maxHeight;
            if (attrs.maxWidth)
                scope.maxWidth = attrs.maxWidth;

            scope.hideModal = function () {
                scope.show = false;
            };

            scope.animationClass = "animation-open";

        }
    }

})();